<template>
  <div class="myOrder">
    <van-nav-bar
      title="我的订单"
      left-text=""
      left-arrow
      fixed
      class="main-nav"
      @click-left="onClickLeft"
    >
      <template #right>
        <div class="goInvoice" @click="goInvoice">开发票</div>
      </template>
    </van-nav-bar>
    <div
      class="myOrder_content"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <div class="tabBox">
        <van-tabs
          v-model:active="activeName"
          @click="onClickTab"
          title-active-color="#2E4344"
          title-inactive-color="#949C9D"
        >
          <van-tab
            :title="item.name"
            :name="item.name"
            v-for="item in tabList"
            :key="item.id"
          ></van-tab>
        </van-tabs>
      </div>
      <div class="myOrder_tabCon">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="finishText"
          @load="onLoad"
        >
          <div class="noData" v-if="list.length == 0">
            <img src="../../assets/images/setting/noData.png" />
            <p>您还没有购买订单</p>
          </div>
          <div v-else>
            <!-- <div class="myOrder_tabCon_list_ago" v-if="activeName =='已购买' ">
              <div class="myOrder_tabCon_list_ago_left">可开发票订单：<span>{{ fapiaoNum }}</span>单</div>
              <div class="myOrder_tabCon_list_ago_right" v-if="Number(fapiaoNum)>0" @click="goFapiao">开发票</div>
            </div> -->
            <div
              class="myOrder_tabCon_list"
              v-for="item in list"
              @click="goDetail(item)"
            >
              <div class="myOrder_tabCon_list_top">
                <div class="myOrder_tabCon_list_top_left">
                  <p class="myOrder_tabCon_list_top_left_name">订单号：</p>
                  <p class="myOrder_tabCon_list_top_left_id">{{ item.id }}</p>
                  <div
                    class="myOrder_tabCon_list_top_left_but"
                    :data-clipboard-text="item.id"
                  >
                    复制
                  </div>
                </div>
                <div class="myOrder_tabCon_list_top_right">
                  <div
                    class="myOrder_tabCon_list_top_right_time"
                    v-if="item.flag == 0"
                  >
                    {{ item.remainingTime | filter_time }}
                  </div>
                  <div
                    class="myOrder_tabCon_list_top_right_name"
                    :style="{
                      color: item.orderState == 0 ? '#FA7D00' : '#949C9D',
                    }"
                  >
                    {{
                      item.orderState == 0
                        ? "待付款"
                        : item.orderState == 1
                        ? "已购买"
                        : item.orderState == 2
                        ? "已取消"
                        : item.orderState == 3
                        ? "退款成功"
                        : ""
                    }}
                    <!-- : item.orderState == 3 &&
                          (item.refundOrderStatus == 1 ||
                            item.refundOrderStatus == 3)
                        ? "退款中"
                        : item.orderState == 3 && item.refundOrderStatus == 2
                        ? "已购买"
                        : item.orderState == 3 && item.refundOrderStatus == 4
                        ? "已撤销"
                        : item.orderState == 3 && item.refundOrderStatus == 5
                        ? "退款成功"
                        : item.orderState == 3 && item.refundOrderStatus == 6
                        ? "退款失败"
                        : "" -->
                  </div>
                </div>
              </div>
              <div class="myOrder_tabCon_list_cen">
                <div class="myOrder_tabCon_list_cen_left">
                  <img
                    :src="item.coverMaterialUrl"
                    class="myOrder_tabCon_list_cen_left_img"
                  />
                  <div
                    class="myOrder_tabCon_list_cen_left_fix"
                    v-if="!item.isFree"
                  >
                    付费
                  </div>
                </div>
                <div class="myOrder_tabCon_list_cen_right">
                  <p>{{ item.productName }}</p>
                  <div class="myOrder_tabCon_list_cen_right_price">
                    <span>¥</span
                    >{{
                      item.originalPrice &&
                      item.originalPrice.toString().indexOf(".") > -1
                        ? item.originalPrice.toString().split(".")[0]
                        : item.originalPrice
                    }}<span
                      v-if="
                        item.originalPrice &&
                        item.originalPrice.toString().indexOf('.') > -1 &&
                        item.originalPrice.toString().split('.')[1]
                      "
                      >.{{ item.originalPrice.toString().split(".")[1] }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="myOrder_tabCon_list_bot">
                <p>
                  下单时间：<span>{{ item.createTime }}</span>
                </p>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { _orderList } from "../../api/setting";
export default {
  name: "myOrder",
  data() {
    return {
      page: 1, //当前页面
      finished: true, // 结束加载
      fapiaoNum: 0, //可开发票订单数
      tabList: [
        //tab列表
        {
          name: "全部",
          id: 0,
        },
        {
          name: "待付款",
          id: 1,
        },
        {
          name: "已购买",
          id: 2,
        },
        {
          name: "退款",
          id: 3,
        },
      ],
      activeName: "全部", //tab选中name
      list: [], //数据列表
      finishText: "", //分页结束话术
      loading: false, //loading标识
      num: "",
    };
  },
  filters: {
    //过滤待付款时间
    filter_time(val) {
      let time = "";
      if (Number(val) < 60) {
        time = "00:" + val;
      } else {
        if (Number(val) % 60 == 0) {
          if (Number(val) / 60 > 9) {
            time = Number(val) / 60 + ":00";
          } else {
            time = "0" + Number(val) / 60 + ":00";
          }
        } else {
          if (parseInt(Number(val) / 60) > 9) {
            time =
              String(parseInt(Number(val) / 60)) +
              ":" +
              String(Number(val) % 60);
          } else {
            time =
              "0" +
              String(parseInt(Number(val) / 60)) +
              ":" +
              String(Number(val) % 60);
          }
        }
      }
      return time;
    },
  },
  created() {
    if (localStorage.getItem("activeName")) {
      this.activeName = localStorage.getItem("activeName");
      this.orderList(
        "downRefresh",
        this.activeName == "待付款"
          ? 0
          : this.activeName == "已购买"
          ? 1
          : this.activeName == "退款"
          ? 3
          : ""
      );
    } else {
      this.orderList();
    }
  },
  mounted() {
    let clipborad = new Clipboard(".myOrder_tabCon_list_top_left_but");
    clipborad.on("success", (e) => {
      this.$toast("复制成功");
    });
  },
  methods: {
    // 返回
    onClickLeft() {
      if (this.$router.app._route.query.sourceType) {
        this.$router.push("/");
      } else {
        this.$router.go(-1);
      }
      localStorage.removeItem("activeName");
    },
    //切换tab
    onClickTab(name, title) {
      document.documentElement.scrollTop = 0; // 滚动到顶部
      this.page = 1;
      this.num =
        name == "待付款" ? 0 : name == "已购买" ? 1 : name == "退款" ? 3 : "";
      this.orderList("", this.num);
      this.activeName = name;
      localStorage.setItem("activeName", name);
    },
    // 滑动加载
    onLoad() {
      this.page++;
      this.orderList("downRefresh", this.num);
    },
    //跳转到开发票页面
    goFapiao() {
      this.$router.push({
        path: "/invoice",
      });
    },
    //跳转到订单详情
    goDetail(item, e) {
      let event = e || window.event;
      let target = event ? event.target || event.srcElement : {};
      if (target && target.className === "myOrder_tabCon_list_top_left_but") {
        return;
      }
      sessionStorage.setItem("orderDetails", JSON.stringify(item));
      if (item.courseType == "1") {
        this.$router.push({
          path: "/myOrderDetail",
          query: { id: item.id },
        });
      } else if (item.courseType == "2" && item.orderState == "0") {
        this.$router.push({
          path: "/outlineOrderConfirm",
          query: { id: item.id },
        });
      } else if (item.courseType == "2" && item.orderState != "0") {
        this.$router.push({
          path: "/offlineOrderDetail",
          query: { id: item.id },
        });
      } else {
        this.$toast("warn:没有获取到课程类型");
      }
    },
    //去开发票
    goInvoice() {
      this.$router.push({
        path: "/invoice",
      });
    },
    // 获取订单列表
    orderList(type, num) {
      this.loading = true;
      this.finished = false;
      _orderList({
        currentPage: this.page,
        pageSize: 10,
        queryData: {
          orderState: num,
        },
      })
        .then((res) => {
          if (res && res.code == 200) {
            if (res.data.record && res.data.record.length > 0) {
              let data = res.data.record;
              if (type == "downRefresh") {
                this.list = [...this.list, ...data];
              } else {
                this.list = data || [];
              }
              if (res.data.pages == this.page || this.list.length == 0) {
                this.finished = true;
                this.finishText = "已加载完全部数据";
              }
            } else {
              this.list = [];
              this.finished = true;
              this.finishText = "";
            }
            this.loading = false;
          } else {
            Toast(res.message);
            this.loading = false;
            this.finished = true;
            this.finishText = "";
          }
        })
        .catch((err) => {
          this.finishText = "";
          this.finished = true;
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.myOrder {
  height: 100%;
  background: #f5f7fa;
  .goInvoice {
    width: 67px;
    height: 28px;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
    border-radius: 14px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 28px;
  }
  .myOrder_content {
    height: 100%;
    padding-top: 91px;
    position: relative;
    .tabBox {
      position: fixed;
      top: 46px;
      width: 100%;
      z-index: 9;
    }
  }
  .myOrder_tabCon {
    margin-top: 8px;
    background: #f5f7fa;
    .myOrder_tabCon_list_ago {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 15px;
      margin-bottom: 8px;
      .myOrder_tabCon_list_ago_left {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6a6f5e;
      }
      .myOrder_tabCon_list_ago_right {
        width: 67px;
        height: 28px;
        background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
        border-radius: 14px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        line-height: 28px;
        margin-right: 15px;
      }
    }
    .myOrder_tabCon_list {
      padding: 15px 10px 12px 8px;
      width: 345px;
      background: #ffffff;
      border-radius: 4px;
      margin-left: 15px;
      margin-bottom: 8px;
      .myOrder_tabCon_list_top {
        display: flex;
        justify-content: space-between;
        .myOrder_tabCon_list_top_left {
          display: flex;
          .myOrder_tabCon_list_top_left_name {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #4d4d4d;
          }
          .myOrder_tabCon_list_top_left_id {
            max-width: 200px;
            overflow: hidden; //超出隐藏
            white-space: nowrap; //不折行
            text-overflow: ellipsis; //溢出显示省略号
            color: #2e4344;
          }
          .myOrder_tabCon_list_top_left_but {
            width: 32px;
            height: 18px;
            background: #f5f7fa;
            border-radius: 2px;
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2e4344;
            text-align: center;
            margin-left: 4px;
          }
        }
        .myOrder_tabCon_list_top_right {
          display: flex;
          .myOrder_tabCon_list_top_right_time {
            font-size: 14px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #fa7d00;
            margin-right: 7px;
          }
          .myOrder_tabCon_list_top_right_name {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }
        }
      }
      .myOrder_tabCon_list_cen {
        display: flex;
        margin-top: 13px;
        .myOrder_tabCon_list_cen_left {
          width: 148px;
          height: 83px;
          border-radius: 4px;
          margin-right: 12px;
          overflow: hidden;
          position: relative;
          .myOrder_tabCon_list_cen_left_img {
            width: 100%;
          }
          .myOrder_tabCon_list_cen_left_fix {
            position: absolute;
            top: 2px;
            right: 2px;
            width: 28px;
            height: 16px;
            background: #1a0801;
            border-radius: 2px;
            line-height: 16px;
            text-align: center;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffe499;
          }
        }
        .myOrder_tabCon_list_cen_right {
          width: 154px;
          p {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2e4344;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          .myOrder_tabCon_list_cen_right_price {
            font-size: 20px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #2e4344;
            margin-top: 19px;
            span {
              font-size: 14px;
              font-family: DINAlternate-Bold, DINAlternate;
              font-weight: bold;
              color: #2e4344;
            }
          }
        }
      }
      .myOrder_tabCon_list_bot {
        margin-top: 8px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #949c9d;
      }
    }
  }
  .noData {
    text-align: center;
    margin: 0 auto;
    margin-top: 84px;
    img {
      width: 140px;
    }
    p {
      margin-top: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #aaaaaa;
    }
  }
}
::v-deep .van-tab {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
::v-deep .van-tabs__wrap {
  overflow: visible;
}
::v-deep .van-tabs__nav--line {
  padding: 0;
}
::v-deep .van-tabs__line {
  width: 20px;
  height: 4px;
  background-color: #0ed7e1;
  border-radius: 0;
  bottom: -4px;
}
</style>
